import React, { useState, useEffect } from "react";

// css
import "./Performance.css";

// components
import PerformanceHeaderCard from "./PerformanceHeaderCard";
import TotalReturns from "./TotalReturns";
import MonthlyTotalReturns from "./MonthlyTotalReturns";
import HistoricNavChart from "./charts/HistoricNavChart";

const PerformanceHeader = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_share_class_performance.json`;

  const [fetchedData, setFetchedData] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [classOption, setClassOption] = useState("Select Share Class");
  const [ayp, setAyp] = useState("");
  const [navAmount, setNavAmount] = useState("");
  const [navDate, setNavDate] = useState("");
  const [totalReturns, setTotalReturns] = useState();
  const [monthlyTotalReturns, setMonthlyTotalReturns] = useState(null);
  const [salesLoad, setSalesLoad] = useState(null);
  const [annualNavs, setAnnualNavs] = useState(null);

  async function fetchData() {
    const response = await fetch(url);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    const filterableData = data.product["share-class"];
    // console.log(data.product["share-class"]);

    setFetchedData(data.product["share-class"]);

    if (filterableData && Array.isArray(filterableData)) {
      const classIItems = filterableData.filter(
        (item) => item.share_class_name === "Class I"
      );
      classIItems.map((items) => {
        // console.log(items);
        setAyp(items.annualized_yield_percent);
        setNavAmount(items.nav_amount);
        setNavDate(items.nav_date);
        setClassOption(items.share_class_name);
        setTotalReturns(items["latest-month-returns"]);
        setMonthlyTotalReturns(items["annual-returns"]);
        setAnnualNavs(items["annual-navs"]);
        setSalesLoad(items.sales_load_percent);
      });
    } else if (
      filterableData &&
      filterableData.share_class_name === "Class I"
    ) {
      setAyp(filterableData.annualized_yield_percent);
      setNavAmount(filterableData.nav_amount);
      setNavDate(filterableData.nav_date);
      setClassOption(filterableData.share_class_name);
      setTotalReturns(filterableData["latest-month-returns"]);
      setMonthlyTotalReturns(filterableData["annual-returns"]);
      setAnnualNavs(filterableData["annual-navs"]);
      setSalesLoad(filterableData.sales_load_percent);
    }
  }

  // run the data fetch on load
  useEffect(() => {
    fetchData();
  }, []);

  const handleStateClick = (
    e,
    ayp,
    nAmount,
    nDate,
    sName,
    totalReturns,
    monthlyReturns,
    salesLoadP,
    annualNavs
  ) => {
    e.preventDefault();
    // console.log("clicked");
    setAyp(ayp);
    setNavAmount(nAmount);
    setNavDate(nDate);
    setClassOption(sName);
    setTotalReturns(totalReturns);
    setMonthlyTotalReturns(monthlyReturns);
    setSalesLoad(salesLoadP);
    setAnnualNavs(annualNavs);
    setShowDropdown();
  };

  return (
    <>
      <section className="performance-header-container" id="performance-header">
        <div className="main-padding">
          <div className="main-margin">
            <div className="performance-header-content-wrapper">
              <h1 class="main-header t-white">Performance</h1>
              <div class="dropdown" style={{ width: "220px" }}>
                <button
                  class="dropbtn"
                  onClick={() => setShowDropdown(!showDropdown)}
                >
                  <span>{classOption}</span> <span>&#9660;</span>
                </button>
                <div
                  class={
                    showDropdown === true
                      ? "dropdown-content-show"
                      : "dropdown-content-hide"
                  }
                >
                  {fetchedData
                    ? fetchedData.map((sClass, i) => {
                        // console.log(typeof(sClass.sales_load_percent))
                        return (
                          <p
                            key={sClass.state_id}
                            onClick={(e) => {
                              handleStateClick(
                                e,
                                sClass.annualized_yield_percent,
                                sClass.nav_amount,
                                sClass.nav_date,
                                sClass.share_class_name,
                                sClass["latest-month-returns"],
                                sClass["annual-returns"],
                                sClass.sales_load_percent,
                                sClass["annual-navs"]
                              );
                              setShowDropdown(false);
                            }}
                          >
                            {sClass.share_class_name}
                          </p>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <PerformanceHeaderCard ayp={ayp} nAmount={navAmount} nDate={navDate} />
      {!ayp ? <div style={{ padding: "100px 0" }}></div> : null}
      {ayp ? (
        <TotalReturns
          data={totalReturns}
          class={classOption}
          load={salesLoad}
        />
      ) : null}
      {ayp ? (
        <MonthlyTotalReturns
          data={monthlyTotalReturns}
          class={classOption}
          load={salesLoad}
        />
      ) : null}
      {ayp ? (
        <HistoricNavChart
          data={annualNavs}
          classOpt={classOption}
          load={salesLoad}
        />
      ) : null}
    </>
  );
};

export default PerformanceHeader;
